import React from "react";
import PtiHistoryTab from "../../pti/components/PtiHistoryTab";

interface VehiclePtiHistoryTabProps {
    vehicleId: number;
}

const VehiclePtiHistoryTab: React.FC<VehiclePtiHistoryTabProps> = ({ vehicleId }) => (
    <PtiHistoryTab assetType="Vehicle" assetId={vehicleId} />
);

export default VehiclePtiHistoryTab;
